import React from 'react';
import './blog-post.css';
import MM1group from './pictures/MM1group.jpg';
import MM1bingo from './pictures/MM1bingo.jpg';
import MM1kahoot from './pictures/MM1kahoot.jpg';
import MM1swag from './pictures/MM1swag.jpg';
import MM1officer from './pictures/MM1officer.jpg';
//import reportWebVitals from './reportWebVitals';

const MM1 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>WiC Fall 2023 Member Meeting 1 Recap</h2>
                    <p class="site-post-meta">October 6th, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Last Friday, we held our first Member Meeting of the school year!   
                    We started the meeting off by introducing the club and officer team to our attendees. Afterwards we spent most of our time getting to know each other with a riveting Bingo Icebreaker, followed by a Group Kahoot filled with questions with topics ranging from pop culture to Computer Science. The winning team, “The Cockroaches”, walked out of that room with fresh new Allen School swag. We then got to introduce our 3 committees to the club, Social Events, Social Media, and Outreach, because applications are closing soon! To end the meeting we raffled off some Allen school t-shirts to 3 of our members. 
                    Thank you so much to everyone who attended - we hope you had a wonderful time and got to meet some great new friends!
                    </p>
                    <img src={MM1group} alt="WiC MM1 group picture"/>
                    <img src={MM1bingo} alt="Members playing bingo"/>
                    <img src={MM1kahoot} alt="Members playing Kahoot"/>
                    <img src={MM1swag} alt="Allen School swag!"/>
                    <img src={MM1officer} alt="WiC officers group picture"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default MM1;

